const wirelessBlock = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E6':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4"
                        showLabelButton="true">
                    <block type="wireless_RCUSendBluetoothData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="wireless_getRCUBleData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothControl"/>
                    <block type="wireless_getBluetoothControlData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothButton"/>
                    <block type="wireless_getBluetoothCode"/>
                    <block type="wireless_getBluetoothRocker"/>
                    ${blockSeparator}
                    <block type="wireless_getComVoice">
                        <value name="TEXT">
                            <shadow type="text">
                                <field name="TEXT">hello</field>
                            </shadow>
                        </value>
                    </block>
                    ${blockSeparator}
                    </category>
                    `;
        case 'C1':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4">
                        <block type="wireless_getIRCode"/>
                        <block type="wireless_getBluetoothControl"/>
                        <block type="wireless_getBluetoothControlData"/>
                        <block type="wireless_getRCUBleData"/>
                        <block type="wireless_RCUSendBluetoothData">
                            <value name="DATA">
                                <shadow type="math_number">
                                    <field name="NUM">50</field>
                                </shadow>
                            </value>
                        </block>
                    </category>
                    `;
        case 'E3':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4">
                        <block type="wireless_getWifiRemote">
                            <value name="KEY">
                                <shadow type="wireless_menu_key">
                                </shadow>
                            </value>
                        </block>
                        <block type="wireless_getWifiVoice">
                            <value name="TEXT">
                                <shadow type="text">
                                    <field name="TEXT">hello</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="wireless_setWifiVoiceString">
                            <value name="LINE">
                                <shadow type="wireless_menu_line">
                                </shadow>
                            </value>
                        </block>
                        <block type="wireless_getWifiPutter"/>
                        <block type="wireless_setWifiUdpMode">
                            <value name="IP">
                                <shadow type="text">
                                    <field name="TEXT">192.168.1.100</field>
                                </shadow>
                            </value>
                            <value name="TELEPORT">
                                <shadow type="math_number">
                                    <field name="NUM">10</field>
                                </shadow>
                            </value>
                            <value name="LOCALPORT">
                                <shadow type="math_number">
                                    <field name="NUM">8080</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="wireless_setWifiData">
                            <value name="DATA">
                                <shadow type="text">
                                    <field name="TEXT">255</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="wireless_getWifiData"/>
                        ${blockSeparator}
                    </category>
                    `;
        case 'M6':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4"
                        showLabelButton="true">
                    <block type="wireless_RCUSendBluetoothData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="wireless_getRCUBleData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothControl"/>
                    <block type="wireless_getBluetoothControlData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothButton"/>
                    <block type="wireless_getBluetoothCode"/>
                    <block type="wireless_getBluetoothRocker"/>
                    ${blockSeparator}
                    <block type="wireless_getComVoice">
                        <value name="TEXT">
                            <shadow type="text">
                                <field name="TEXT">hello</field>
                            </shadow>
                        </value>
                    </block>
                    ${blockSeparator}
                    </category>
                    `;
        case 'C6':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4"
                        showLabelButton="true">
                    <block type="wireless_RCUSendBluetoothData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="wireless_getRCUBleData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothControl"/>
                    <block type="wireless_getBluetoothControlData"/>
                    ${blockSeparator}
                    <block type="wireless_getBluetoothButton"/>
                    <block type="wireless_getBluetoothCode"/>
                    <block type="wireless_getBluetoothRocker"/>
                    ${blockSeparator}
                    <block type="wireless_getComVoice">
                        <value name="TEXT">
                            <shadow type="text">
                                <field name="TEXT">hello</field>
                            </shadow>
                        </value>
                    </block>
                    ${blockSeparator}
                    </category>
                    `;
        case 'E7':
            return `
                <category
                    name="%{BKY_CATEGORY_WIRELESS}"
                    id="wireless"
                    colour="#20c5d4"
                    secondaryColour="#20c5d4"
                    showLabelButton="true">
                <block type="wireless_getRCUBleData"/>
                <block type="wireless_RCUSendBluetoothData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="wireless_getComVoice">
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="wireless_getBluetoothControl"/>
                <block type="wireless_getBluetoothControlData"/>
                <block type="wireless_getBluetoothButton"/>
                <block type="wireless_getBluetoothCode"/>
                <block type="wireless_getBluetoothRocker"/>
                ${blockSeparator}
                </category>
                `;

        case 'STORM_OS':
            return `
                <category
                    name="%{BKY_CATEGORY_WIRELESS}"
                    id="wireless"
                    colour="#20c5d4"
                    secondaryColour="#20c5d4"
                    showLabelButton="true">
                <block type="wireless_getRCUBleData"/>
                <block type="wireless_RCUSendBluetoothData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="wireless_getComVoice">
                    <value name="TEXT">
                        <shadow type="text">
                            <field name="TEXT">hello</field>
                        </shadow>
                    </value>
                </block>
                <block type="wireless_getBluetoothControl"/>
                <block type="wireless_getBluetoothControlData"/>
                <block type="wireless_getBluetoothButton"/>
                <block type="wireless_getBluetoothCode"/>
                <block type="wireless_getBluetoothRocker"/>
                ${blockSeparator}
                </category>
                `;
        case 'M5':
            return `
                    <category
                        name="%{BKY_CATEGORY_WIRELESS}"
                        id="wireless"
                        colour="#20c5d4"
                        secondaryColour="#20c5d4">
                    <block type="wireless_M5_GetRFModuleRemoteButton"/>
                    <block type="wireless_M5_GetRFModuleRemoteCode"/>
                    <block type="wireless_M5_GetRFModuleRemoteRocker"/>
                    <block type="wireless_M5_getBluetoothControl"/>
                    <block type="wireless_M5_getBluetoothControlData"/>
                    ${blockSeparator}
                    </category>
                    `;
        default:
            return `
                <category
                    name="%{BKY_CATEGORY_WIRELESS}"
                    id="wireless"
                    colour="#20c5d4"
                    secondaryColour="#20c5d4">
                </category>
                `;
    }
};

export default wirelessBlock;
